import { AvailabilityToDisplay } from 'services/userPreferences/types';
import { availability, sourcingDetails } from 'services/cart/types';
import {
  ProductAvailabilityBackorder,
  ProductAvailabilityByDate,
  ProductAvailabilityBySource
} from '.';
import { LocationAddress } from 'services/location/types';

export interface ProductAvailabilityProps {
  sourcingDetails?: sourcingDetails[];
  availability?: availability[];
  availabilityToDisplay?: AvailabilityToDisplay;
  isBackorder?: boolean;
  isCompact?: boolean;
  shouldWrap?: boolean;
  storeAddress?: LocationAddress;
  hasValidateCartError?: boolean;
  openInDrawer?: boolean;
}

export function ProductAvailability({
  sourcingDetails,
  availability,
  availabilityToDisplay,
  storeAddress,
  isBackorder = false,
  isCompact = false,
  shouldWrap = false,
  hasValidateCartError = false,
  openInDrawer = false
}: Readonly<ProductAvailabilityProps>) {
  if (hasValidateCartError) return <></>;

  if (isBackorder || (!sourcingDetails?.length && availability?.length)) {
    return (
      <ProductAvailabilityBackorder
        availability={availability}
        isCompact={isCompact}
        shouldWrap={shouldWrap}
        storeAddress={storeAddress}
      />
    );
  }

  if (availabilityToDisplay === 'D') {
    return (
      <ProductAvailabilityByDate
        address={storeAddress}
        sourcingDetails={sourcingDetails}
        isCompact={isCompact}
        shouldWrap={shouldWrap}
        openInDrawer={openInDrawer}
      />
    );
  }

  return (
    <ProductAvailabilityBySource
      sourcingDetails={sourcingDetails}
      isCompact={isCompact}
      shouldWrap={shouldWrap}
      storeAddress={storeAddress}
    />
  );
}
